import React, { useEffect, useRef } from 'react';
import styles from '../../styles/scss/components/tips/productsSection.module.scss';

const ProductsSection = ({ data }) => {
  const sectionRef = useRef(null);
  const leftProductRef = useRef(null);
  const centerProductRef = useRef(null);
  const rightProductRef = useRef(null);
  const backgroundRef = useRef(null);
  

  useEffect(() => {
    if (!backgroundRef.current) return;
    
    const options = {
      root: null, 
      rootMargin: '50px', 
      threshold: 0.15 
    };
    
    const handleIntersection = (entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          if (leftProductRef.current) {
            leftProductRef.current.classList.add(styles.animateLeft);
          }
          if (centerProductRef.current) {
            centerProductRef.current.classList.add(styles.animateCenter);
          }
          if (rightProductRef.current) {
            rightProductRef.current.classList.add(styles.animateRight);
          }
        }
      });
    };
    
    const observer = new IntersectionObserver(handleIntersection, options);
    observer.observe(backgroundRef.current); 
    
    return () => {
      if (backgroundRef.current) {
        observer.unobserve(backgroundRef.current);
      }
    };
  }, []);
  
  return (
    <div className={styles.productSection} ref={sectionRef}>
      <h2 className={styles.productTitle}>{data.title}</h2>
      
      <div className={styles.productComposition}>
        <div className={styles.productContainer}>
          {/* Left product - Silicone */}
          <div className={`${styles.product} ${styles.productLeft}`} ref={leftProductRef}>
            <a href={data.galleryImages.find(img => img.id === 'silicone').productUrl}>
              <img 
                src={data.galleryImages.find(img => img.id === 'silicone').url} 
                alt={data.galleryImages.find(img => img.id === 'silicone').alt} 
                className={styles.productImage}
              />
            </a>
          </div>
          {/* Center product - Gel Lube */}
          <div className={`${styles.product} ${styles.productCenter}`} ref={centerProductRef}>
            <a href={data.galleryImages.find(img => img.id === 'gel-lube').productUrl}>
              <img 
                src={data.galleryImages.find(img => img.id === 'gel-lube').url} 
                alt={data.galleryImages.find(img => img.id === 'gel-lube').alt} 
                className={styles.productImage}
              />
            </a>
          </div>
          {/* Right product - Penetrant */}
          <div className={`${styles.product} ${styles.productRight}`} ref={rightProductRef}>
            <a href={data.galleryImages.find(img => img.id === 'penetrant').productUrl}>
              <img 
                src={data.galleryImages.find(img => img.id === 'penetrant').url} 
                alt={data.galleryImages.find(img => img.id === 'penetrant').alt} 
                className={styles.productImage}
              />
            </a>
          </div>
        </div>
      </div>
      
      <a href="https://where-to-buy.co/widgets/core/BNI-SS/index.html?pid=12046011&campaignId=c8xuNvP8U3cOfv8I5282P2Vvd2EI5HxH" className={styles.buyButton}>WHERE TO BUY</a>
      
      <img 
        src={data.background} 
        alt="Product Background" 
        className={styles.productBackground}
        ref={backgroundRef}
      />
    </div>
  );
};

export default ProductsSection;
